import React, {useState} from 'react'
import Diagnosis from '../../layout-inpatient/tab-components/Diagnosis'
import PatientDetails from '../../layout-inpatient/tab-components/PatientDetails'
import Documents from '../../layout-inpatient/tab-components/Documents'
import DocumentsFGL from '../../layout-inpatient/tab-components/DocumentsFGL'
import Billing from '../../layout-inpatient/Billing'
import CalendarPage from '../../layout-inpatient/tab-components/Calendar'
import DailyMonitoringPage from './DailyMonitoring'
import SettlementDocument from './SettlementDocument'
import {
  FaExclamationCircle,
  FaFile,
  FaUserCircle,
  FaSearch,
  FaFileInvoiceDollar,
  FaCalendarAlt,
  FaFolderOpen,
  FaClipboardList,
  FaFileAlt,
} from 'react-icons/fa'

interface SettlementDetailPageProps {
  claimDetails: any
  onDocumentsStatusChange: (status: boolean) => void
  isEditingDiagnosis: boolean
  onEditClick: () => void
  onDocumentClick: (docLabel: string) => void
  onValidateDiagnosis: (diagnosisData: any) => void
  isFromDailyMonitoring?: boolean
  onDocumentRealtimeUpdate?: (data: any) => void
  onDiagnosisDataChange: (data: any) => void
  isRequestFGL?: boolean
  currentView?: 'inpatient' | 'calendar' | 'dailyMonitoringDetail' | 'discharged' | 'settlement'
}

const SettlementDetailPage: React.FC<SettlementDetailPageProps> = ({
  claimDetails,
  onDocumentsStatusChange,
  isEditingDiagnosis,
  onEditClick,
  onDocumentClick,
  onValidateDiagnosis,
  isFromDailyMonitoring = false,
  onDocumentRealtimeUpdate,
  onDiagnosisDataChange,
  isRequestFGL = false,
  currentView = 'inpatient',
}) => {
  const claimStatus = claimDetails?.claimDetails?.status
  const isFGLRequest =
    (claimStatus === 'Request FGL' ||
      claimStatus === 'FGL RELEASED' ||
      claimStatus === 'Final Document Complete' ||
      claimStatus === 'FGL Review' ||
      claimStatus === 'Pending on FGL') &&
    currentView === 'settlement'

  // Set default tab based on claim status
  const defaultTab =
    claimStatus === 'Pending on FGL' ||
    claimStatus === 'FGL RELEASED' ||
    claimStatus === 'Request FGL' ||
    claimStatus === 'Final Document Complete' ||
    claimStatus === 'FGL Review'
      ? 'Documents FGL'
      : 'Diagnosis'

  const [activeTab, setActiveTab] = useState(defaultTab)
  const [isReupload, setIsReupload] = useState(false)

  const [diagnosisData, setDiagnosisData] = useState({
    mainDiagnosis: '',
    supportingDiagnosis: '',
    supportingDiagnosis3: '',
    doctor: '',
    polyName: '',
    polyCode: '',
    remark: '',
    fax: '',
    deposit: '',
    originalIcdCodes: {
      icd1: '',
      icd2: '',
      icd3: '',
    },
  })

  const handleDiagnosisDataChange = (newData: any) => {
    setDiagnosisData((prev) => ({
      ...prev,
      ...newData,
    }))
    onDiagnosisDataChange(newData)
  }

  const documentsTabLabel = isFGLRequest ? 'Documents FGL' : 'Documents'

  const renderTabContent = () => {
    const claimStatus = claimDetails?.claimDetails?.status
    const isFGLRequest =
      claimStatus === 'Request FGL' ||
      claimStatus === 'FGL RELEASED' ||
      claimStatus === 'Final Document Complete' ||
      claimStatus === 'Pending on FGL'

    switch (activeTab) {
      case 'Diagnosis':
        return (
          <Diagnosis
            claimDetails={claimDetails}
            isEditing={isEditingDiagnosis}
            onEditClick={onEditClick}
            onValidateDiagnosis={onValidateDiagnosis}
            isFromDailyMonitoring={isFromDailyMonitoring}
            diagnosisData={diagnosisData}
            onDiagnosisDataChange={handleDiagnosisDataChange}
          />
        )
      case 'Patient Details':
        return <PatientDetails claimDetails={claimDetails} />
      case 'Documents':
        return !isFGLRequest ? (
          <Documents
            claimDetails={claimDetails}
            onDocumentClick={onDocumentClick}
            onDocumentsStatusChange={onDocumentsStatusChange}
            onDocumentRealtimeUpdate={onDocumentRealtimeUpdate}
          />
        ) : (
          <Documents
            claimDetails={claimDetails}
            onDocumentClick={onDocumentClick}
            onDocumentsStatusChange={onDocumentsStatusChange}
            onDocumentRealtimeUpdate={onDocumentRealtimeUpdate}
          />
        )
      case 'Documents FGL':
        return isFGLRequest ? (
          <DocumentsFGL
            claimDetails={claimDetails}
            onDocumentClick={onDocumentClick}
            onDocumentsStatusChange={onDocumentsStatusChange}
            onDocumentRealtimeUpdate={onDocumentRealtimeUpdate}
            setIsReupload={setIsReupload}
          />
        ) : (
          <DocumentsFGL
            claimDetails={claimDetails}
            onDocumentClick={onDocumentClick}
            onDocumentsStatusChange={onDocumentsStatusChange}
            onDocumentRealtimeUpdate={onDocumentRealtimeUpdate}
            setIsReupload={setIsReupload}
          />
        )
      case 'Billing':
        return <Billing claimDetails={claimDetails} />
      case 'Daily Monitoring':
        return <DailyMonitoringPage claimDetails={claimDetails} />
      case 'Documents Settlement':
        return (
          <SettlementDocument
            claimDetails={claimDetails}
            onDocumentClick={onDocumentClick}
            onDocumentsStatusChange={onDocumentsStatusChange}
            onDocumentRealtimeUpdate={onDocumentRealtimeUpdate}
          />
        )
      default:
        return null
    }
  }

  console.log('Claim Details InpatientPage : ', JSON.stringify(claimDetails.claimDetails.status))

  const tabStyle = {
    cursor: 'pointer',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    backgroundColor: 'white',
  }

  const activeTabStyle = {
    backgroundColor: 'rgba(243, 245, 247, 1)',
    color: '#000',
  }

  console.log('Apa ini : ', isFGLRequest)
  console.log('Active Tabs : ', activeTab)
  console.log('Current View: ', currentView)
  return (
    <>
      <div className='frame-settlement'>
        <div className='frame-tabs'>
          <div
            className={`frame-tab1 ${activeTab === 'Diagnosis' ? 'active' : ''}`}
            onClick={() => setActiveTab('Diagnosis')}
            style={{...tabStyle, ...(activeTab === 'Diagnosis' ? activeTabStyle : {})}}
          >
            <div className='frame-row13'>
              <div className='frame-icontab1'>
                <div className='frame-diagnosis'>
                  <div className='frame-general1'>
                    <div className='frame-debugtools1'>
                      <FaSearch className='frame-icon' />
                    </div>
                  </div>
                </div>
              </div>
              <span className='frame-text12 webbodysinglemedium'>Diagnosis</span>
            </div>
          </div>
          <div
            className={`frame-tab2 ${activeTab === 'Patient Details' ? 'active' : ''}`}
            onClick={() => setActiveTab('Patient Details')}
            style={{...tabStyle, ...(activeTab === 'Patient Details' ? activeTabStyle : {})}}
          >
            <div className='frame-row14'>
              <div className='frame-icontab2'>
                <div className='frame-patient'>
                  <div className='frame-icon'>
                    <FaUserCircle className='frame-icon' />
                  </div>
                </div>
              </div>
              <span className='frame-text13 webbodysinglemedium'>Patient Details</span>
            </div>
          </div>
          <div
            className={`frame-tab3 ${activeTab === 'Documents' ? 'active' : ''}`}
            onClick={() => setActiveTab('Documents')}
            style={{...tabStyle, ...(activeTab === 'Documents' ? activeTabStyle : {})}}
          >
            <div className='frame-row15'>
              <div className='frame-document1'>
                <div className='frame-filesfolders2'>
                  <div className='frame-document2'>
                    <FaFile className='frame-icon' />
                  </div>
                </div>
              </div>
              <span className='frame-text14 webbodysinglemedium'>Documents Admission</span>
            </div>
          </div>
          <div
            className={`frame-tab3 ${activeTab === 'Daily Monitoring' ? 'active' : ''}`}
            onClick={() => setActiveTab('Daily Monitoring')}
            style={{...tabStyle, ...(activeTab === 'Daily Monitoring' ? activeTabStyle : {})}}
          >
            <div className='frame-row15'>
              <div className='frame-document1'>
                <div className='frame-filesfolders2'>
                  <div className='frame-document2'>
                    <FaCalendarAlt className='frame-icon' />
                  </div>
                </div>
              </div>
              <span className='frame-text14 webbodysinglemedium'>Daily Monitoring</span>
            </div>
          </div>
          <div
            className={`frame-tab3 ${activeTab === 'Billing' ? 'active' : ''}`}
            onClick={() => setActiveTab('Billing')}
            style={{...tabStyle, ...(activeTab === 'Billing' ? activeTabStyle : {})}}
          >
            <div className='frame-row15'>
              <div className='frame-document1'>
                <div className='frame-filesfolders2'>
                  <div className='frame-document2'>
                    <FaFileInvoiceDollar className='frame-icon' />
                  </div>
                </div>
              </div>
              <span className='frame-text14 webbodysinglemedium'>Billing</span>
            </div>
          </div>
          <div
            className={`frame-tab3 ${activeTab === 'Documents FGL' ? 'active' : ''}`}
            onClick={() => setActiveTab('Documents FGL')}
            style={{...tabStyle, ...(activeTab === 'Documents FGL' ? activeTabStyle : {})}}
          >
            <div className='frame-row15'>
              <div className='frame-document1'>
                <div className='frame-filesfolders2'>
                  <div className='frame-document2'>
                    <FaFolderOpen className='frame-icon' />
                  </div>
                </div>
              </div>
              <span className='frame-text14 webbodysinglemedium'>Documents FGL</span>
            </div>
          </div>
          <div
            className={`frame-tab3 ${activeTab === 'Documents Settlement' ? 'active' : ''}`}
            onClick={() => setActiveTab('Documents Settlement')}
            style={{...tabStyle, ...(activeTab === 'Documents Settlement' ? activeTabStyle : {})}}
          >
            <div className='frame-row15'>
              <div className='frame-document1'>
                <div className='frame-filesfolders2'>
                  <div className='frame-document2'>
                    <FaFileAlt className='frame-icon' />
                  </div>
                </div>
              </div>
              <span className='frame-text14 webbodysinglemedium'>Documents Settlement</span>
            </div>
          </div>
        </div>
        <div className='frame-content' style={{paddingLeft: '90px', paddingRight: '90px'}}>
          {renderTabContent()}
        </div>
      </div>
    </>
  )
}

export default SettlementDetailPage
